import request from '../../../config/Request'

const monitor = {
    monitorCarDisList:'/api/Monitor/queryCarDisList',// 查询车辆分布实时列表
    monitorCarTraList:'/api/Monitor/queryCarTraList',// 查询车辆轨迹实时列表
    monitorAlarmList:'/api/Monitor/queryAlarmList',// 查询告警信息
};
/**
 * 查询车辆分布实时列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function grtMonitorCarDisList(parameter) {
    return request({
        url: monitor.monitorCarDisList,
        data: parameter
    })
}
/**
 * 查询车辆轨迹实时列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function grtMonitorCarTraList(parameter) {
    return request({
        url: monitor.monitorCarTraList,
        data: parameter
    })
}
